import mock from './mock';
import axios from 'axios';
import config from 'config';
import urlUtil from '../../utils/url';
import backendConfig from '../../utils/backendConfig';
import backend from '../../utils/backend';

function fetchAll(sso) {
  return backendConfig.get().then(({backendUrl}) => {
    let url = `${backendUrl}${config.backend.feeds.mailingLists}?sso=${sso}`;
    url = urlUtil.randomize(url);
    return axios.get(url).then(resp => {
      const mailingLists = resp.data || [];

      for (const firstLevelItem of mailingLists) {
        if (firstLevelItem.type === 'topic' && !firstLevelItem.children) {
          firstLevelItem.children = [];
        }

        if (firstLevelItem.children) {
          firstLevelItem.children.sort((a, b) => -(b.order - a.order));
        }
      }

      mailingLists.sort((a, b) => -(b.order - a.order));

      return mailingLists;
    }).catch((error) => {
      const resp = error.response;
      resp.body = resp.data;
      if (backend.ssoIsInvalid(resp)) {
        backend.redirectToAnonymousAuth();
        reject();
        return;
      };
    });
  });
}

export default {
  fetchAll,
};



// WEBPACK FOOTER //
// ./src/models/mailing-lists/storage.js